import * as angular from 'angular';
import { Constants as constants } from '@constants/shared';
import { reportingMain } from './reporting_main';
import { portfolioSummaryReport } from './portfolio/report'

export const reportingModule = 'reporting';

angular
  .module(reportingModule, ['LocalStorageModule', 'ngMaterial', 'isoCurrency'])
  .constant("config", constants.Default)
  .component("reportingMain", reportingMain)
  .component("portfolioSummaryReport", portfolioSummaryReport)
  .config(['cfpLoadingBarProvider', function (cfpLoadingBarProvider) {
    cfpLoadingBarProvider.parentSelector = '#loader';
    cfpLoadingBarProvider.includeSpinner = false;
    cfpLoadingBarProvider.includeBar = false;
  }]);




// WEBPACK FOOTER //
// ./src/app/reporting/reporting.index.ts